import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

const STORAGE_KEY    = "720mt_session";
const SESSION_VER    = "1.10";            // bump para limpiar datos de versiones anteriores

const defaultState = {
  idea: "",
  chatHistory: [],
  promptEng: "",
  promptEsp: "",
  mdvObject: null,
  hashtag_id: "",
  promptFinal: "",
  autoGenerate: false,
  motor: "sdxl",
  resumen: "",
  editImageId: null,
};

function loadFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultState;
    const parsed = JSON.parse(raw);
    // Si la versión no coincide, descartar datos y arrancar limpio
    if (parsed._v !== SESSION_VER) {
      localStorage.removeItem(STORAGE_KEY);
      return defaultState;
    }
    return {
      ...defaultState,
      ...parsed,
      chatHistory: Array.isArray(parsed.chatHistory) ? parsed.chatHistory : [],
    };
  } catch {
    localStorage.removeItem(STORAGE_KEY);
    return defaultState;
  }
}

function saveToStorage(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...state, _v: SESSION_VER }));
  } catch {}
}

export const AppContext = createContext({
  ...defaultState,
  setIdea: () => {},
  setChatHistory: () => {},
  setPromptEng: () => {},
  setPromptEsp: () => {},
  setMdvObject: () => {},
  setHashtagId: () => {},
  setPromptFinal: () => {},
  setAutoGenerate: () => {},
  setMotor: () => {},
  setResumen: () => {},
  setEditImageId: () => {},
  clearAll: () => {},
});

export function AppProvider({ children }) {
  const [state, setState] = useState(loadFromStorage);

  // Persist to localStorage on every change
  useEffect(() => {
    saveToStorage(state);
  }, [state]);

  const setField = useCallback((field) => (value) => {
    setState(prev => ({ ...prev, [field]: value }));
  }, []);

  const clearAll = useCallback(() => {
    setState(defaultState);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  const value = {
    ...state,
    setIdea:        setField("idea"),
    setChatHistory: setField("chatHistory"),
    setPromptEng:   setField("promptEng"),
    setPromptEsp:   setField("promptEsp"),
    setMdvObject:   setField("mdvObject"),
    setHashtagId:   setField("hashtag_id"),
    setPromptFinal: setField("promptFinal"),
    setAutoGenerate: setField("autoGenerate"),
    setMotor: setField("motor"),
    setResumen: setField("resumen"),
    setEditImageId: setField("editImageId"),
    clearAll,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useApp() {
  return useContext(AppContext);
}
